var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"comment-box"},[_c('div',{staticClass:"comment-area"},[_c('editor',{attrs:{"placeholder":_vm.placeholder,"replyResult":_vm.replyResult}})],1),_vm._v(" "),_c('div',{staticClass:"comment-foot",on:{"click":_vm.saveData}},[_c('div',[_vm._v(_vm._s(_vm.bnt_text))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c95d3584","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Approval/comment/index.vue
// module id = null
// module chunks = 